// extracted by mini-css-extract-plugin
export var actionButton = "_is-0";
export var fileInput = "_is-2";
export var paperclip = "_is-1";